import styled from 'styled-components';
import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

import Process1Image from 'resources/videoLanding/process_1.svg';
import Process2Image from 'resources/videoLanding/process_2.svg';
import Process3Image from 'resources/videoLanding/process_3.svg';
import Process4Image from 'resources/videoLanding/process_4.svg';
import Arrow from 'resources/videoLanding/process_arrow.svg';

const Process = () => {

  const processAnime = useScrollFadeIn({threshold: 0.3, delay: '0.1', direction: 'bottomUp'});

  return (
    <Container>
      <ProcessContainer {...processAnime}>
        <Title>작업 프로세스</Title>
        <Description>브리피는 이렇게 작업합니다</Description>
        <MobileDescription>브리피는 이렇게 작업합니다</MobileDescription>
        <ProcessWrapper>
          <ItemWrapper>
            <Image><img src={Process1Image} /></Image>
            <SubTitle>제작 상담</SubTitle>
            <SubDescription>다양한 레퍼런스에 기반하여 여러 제작 방향을 제안하고 함께 결정합니다</SubDescription>
          </ItemWrapper>
          <ItemWrapper>
            <img className='arrow' src={Arrow} />
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process2Image} /></Image>
            <SubTitle>제작사 매칭</SubTitle>
            <SubDescription>제작 예산, 일정, 콘셉트 등에 맞춰  최적의 제작사를 연결합니다</SubDescription>
          </ItemWrapper>
          <ItemWrapper>
            <img className='arrow' src={Arrow} />
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process3Image} /></Image>
            <SubTitle>촬영 준비</SubTitle>
            <SubDescription>촬영 기획안을 제작하고 촬영에 필요한 장소, 모델 등을 섭외합니다</SubDescription>
          </ItemWrapper>
          <ItemWrapper>
            <img className='arrow' src={Arrow} />
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process4Image} /></Image>
            <SubTitle>제작 납품</SubTitle>
            <SubDescription>촬영 및 편집을 진행하고 고객 컨펌을 거쳐 결과물을 납품합니다</SubDescription>
          </ItemWrapper>
        </ProcessWrapper>
        <MobileProcessWrapper>
          <ItemWrapper>
            <Image><img src={Process1Image} /></Image>
            <MobileSubWrapper>
              <SubTitle>제작 상담</SubTitle>
              <SubDescription>다양한 레퍼런스에 기반하여 여러 제작 방향을 제안하고 함께 결정합니다</SubDescription>
            </MobileSubWrapper>
          </ItemWrapper>
          <ItemWrapper>
            <div className='arrowDiv'><img className='arrow' src={Arrow} /></div>
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process2Image} /></Image>
            <MobileSubWrapper>
              <SubTitle>제작사 매칭</SubTitle>
              <SubDescription>제작 예산, 일정, 콘셉트 등에 맞춰  최적의 제작사를 연결합니다</SubDescription>
            </MobileSubWrapper>
          </ItemWrapper>
          <ItemWrapper>
            <div className='arrowDiv'><img className='arrow' src={Arrow} /></div>
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process3Image} /></Image>
            <MobileSubWrapper>
              <SubTitle>촬영 준비</SubTitle>
              <SubDescription>촬영 기획안을 제작하고 촬영에 필요한 장소, 모델 등을 섭외합니다</SubDescription>
            </MobileSubWrapper>
          </ItemWrapper>
          <ItemWrapper>
            <div className='arrowDiv'><img className='arrow' src={Arrow} /></div>
          </ItemWrapper>
          <ItemWrapper>
            <Image><img src={Process4Image} /></Image>
            <MobileSubWrapper>
              <SubTitle>제작 납품</SubTitle>
              <SubDescription>촬영 및 편집을 진행하고 고객 컨펌을 거쳐 결과물을 납품합니다</SubDescription>
            </MobileSubWrapper>
          </ItemWrapper>
        </MobileProcessWrapper>
      </ProcessContainer>
    </Container>
  )
}

export default Process;

const Container = styled.div`
  display: flex;
  width: 100%;  
  margin: 0 auto;
`

const ProcessContainer = styled.div`
  width: 1088px;
  // height: 271px;
  margin: 0 auto;
  padding: 180px 0;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    // height: 738px;
    margin: 0;
    padding: 60px 16px;
  }
`

const Title = styled.div`
  text-align: center;
  color: #2C2C2C;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  
  @media ${({theme}) => theme.device.mobile} {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
  }
`

const Description = styled.div`
  margin-top: 8px;
  margin-bottom: 80px;
  text-align: center;
  font-size: 18px;
  font-weight: 200;
  line-height: 24px; /* 133.333% */
  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileDescription = styled.div`
  display: none;  
  @media ${({theme}) => theme.device.mobile} {
    text-align: center;
    font-size: 13px;
    font-weight: 200;
    line-height: 16px;
    margin: 5px 0 25px;
    display: block;
    padding: 0 5px;
    color: #ABABAC;
  }
`

const ProcessWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
` 

const ItemWrapper = styled.div`
  width: 186px;

  .arrow {
    padding: 67px 17px;
  }

  @media ${({theme}) => theme.device.mobile} {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 13px;
    font-weight: 300;
    line-height: 15px;
    text-align: left;

    .arrow {
      width: 20px;
      padding: 0;
      margin: 0 3px;
      transform: rotate(90deg);
    }

    .arrowDiv {
      width: 300px;
      height: 35px;
      padding: 5px 0 10px 35px;
    }
  }
`

const Image = styled.div`
  width: 146px;
  height: 146px;
  padding: 24px;
  border-radius: 50%;
  background: #FFFFFF;
  filter: drop-shadow(2px 2px 8px rgba(0, 0, 0, 0.10));
  margin-bottom: 31px;
  margin-left: 20px;
    
  @media ${({theme}) => theme.device.mobile} {
    width: 56px;
    height: 56px;
    padding: 10px;
    margin-right: 20px;
    margin-bottom: 0;

    img {
      width: 36px;
      height: 36px;
    }
  }
`

const SubTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
  text-align: center;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    text-align: left;
  }
`

const SubDescription = styled.div`
  width: 186px;
  margin-top: 8px;
  color: #4B4B4B;
  text-align: center;
  font-size: 13px;
  font-weight: 300;
  line-height: 18px; /* 138.462% */

  @media ${({theme}) => theme.device.mobile} {
    width: 212px;
    margin-top: 5px;
    text-align: left;
    font-size: 12px;
    font-weight: 200;
    line-height: 15px;
  }
`

const MobileProcessWrapper = styled.div`
  display: none;
  
  @media ${({theme}) => theme.device.mobile} { 
    display: flex;
    flex-direction: column;
  }
`

const MobileSubWrapper = styled.div`
  padding: 3px 0;
`